import * as actions from '../actionTypes';


export const setSelectedStudent = (student) => async (dispatch) => {
    try {   
        const action = { type: actions.SET_SELECTED_STUDENT, payload: student };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
export const unsetSelectedStudent = () => async (dispatch) => {
    try {       
        const action = { type: actions.UNSET_SELECTED_STUDENT };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
export const setSelectedSubjectInstance = (subjectInstance) => async (dispatch) => {
    try {    
        const action = { type: actions.SET_SELECTED_SUBJECT_INSTANCE, payload: subjectInstance };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
export const unsetSelectedSubjectInstance = () => async (dispatch) => {
    try {       
        const action = { type: actions.UNSET_SELECTED_SUBJECT_INSTANCE };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}



